import React, { useEffect, useState } from "react";
import styles from "../../../styles/pages/approvalForm.module.scss";
import Icons from "../../../public/assets/svg";
import Dropdown from "../../listWithoutcheck";
import { useRouter } from "next/router";
import axios from "axios";
import BasicForm from "../../basicForm";
import endpoints from "../../../utility/endpoints";
import _ from "lodash";
import SuccessModal from "../../../pages/successModal";
import router from "next/router";
import UploadFile from "../../uploadFile";
import { BlobServiceClient } from "@azure/storage-blob";
import endPoints from "../../../utility/endpoints";
import {
  sessionTimeOutCheck,
  checkExpiry,
} from "../../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Loader from "../../Loader";

function index(props) {
  







  let dropDownAr = [
    {
      field_form_field_title: "1. Please select the Process Area",
      field_label: "1. Please select the Process Area",
      field_input_type: "Dropdown",
      field_related_dropdown: "2. Please select the Sub-Process Area",
      field_options: ["General", "MTD", "OTC", "STP", "RTR"],
      field_input: "Select process area",
      field_message_ip_error_message: "Area is mandatory",
      field_required: "1",
      field_dropdown_option_component: [
        {
          field_title: "",
          field_options: [],
        },
      ],
      field_editable: "",
    },
    {
      field_form_field_title: "2. Please select the Sub-Process Area",
      field_label: "2. Please select the Sub-Process Area",
      field_input_type: "Related Dropdown",
      field_related_dropdown: "",
      field_options: [],
      field_input: "Select sub-process area",
      field_message_ip_error_message: "Area is mandatory",
      field_required: "1",
      field_dropdown_option_component: [
        {
          field_title: "General",
          field_options: ["Local Table of Authorities"],
        },
        {
          field_title: "MTD",
          field_options: [
            "SCF -Inventory Valuation and Variance analysis",
            "Make - Production and physical inventory movements",
            "Make & Deliver - Production and physical inventory movements",
            "Deliver - Production and physical inventory movements",
            "Make & Deliver - Physical verification/ consignment",
            "SCF - Obsolete and Unsalable",
            "SCF - Transfer Pricing",
            "Master Data",
            "Make - BOM Maintenance",
            "SCF - Production and Physical Inventory Movement",
          ],
        },
        {
          field_title: "OTC",
          field_options: [
            "Credit Management",
            "Master Data",
            "Order Fulfilment",
            "Customer Billing",
            "Creation of Rebate Accruals",
            "Review of rebate accruals",
            "Rebate claims processing",
            "Credit / Debit Notes",
            "Cash Application",
            "Accounts Receivable",
            "Order Management",
            "Refusals / Returns",
          ],
        },
        {
          field_title: "STP",
          field_options: [
            "Master Data",
            "Invoice Processing",
            "Data transfer",
            "POs Coupa",
            "POs Production Item (SAP POs)",
            "Contract approval",
            "PO Invoices",
            "Invoice receipt and Validation",
            "Blocked Invoices Review",
            "Payments",
            "NON SAP system Time and Expenses",
          ],
        },
        {
          field_title: "RTR",
          field_options: [
            "Journal Entries",
            "Reclassification of balances",
            "Inter-Company",
            "Reporting",
            "Master Data",
            "Foreign Currency",
            "Period Close",
            "Open/Close Accounting Periods",
            "Reconciliations",
            "Fixed Assets",
            "Payroll",
            "Leases",
            "Sundry Invoices",
            "Allocations",
            "Depreciation",
            "VAT",
            "Prepare Statutory Reporting",
          ],
        },
      ],
    },
  ];






const [state, setState] = React.useState({
    controlActivity: null,
    controlActivityType: "None",
    kfaIuc: null,
    dropData: {},
    controlNumber: '',
  });  

  const [submitForm, setSubmitForm] = React.useState(false);
  const [getFormValues, setGetFormValues] = React.useState(false);
  const [emptyFormValues, setEmptyFormValues] = React.useState(false);
  const [fail, setFail] = useState(false);
  const [showFileName, setShowFileName] = useState(false);
  const router = useRouter();
  const [Loading, setLoading] = useState(false);
  const [processData, setProcessData] = useState({});
  const [successModal, setSuccessModal] = useState(false);
  const [message, setMessage] = useState("");
  const [authData, setAuthData] = React.useState("");
  const [userType, setUserType] = React.useState("");
  const [invalidFlag, setInvalidFlag] = useState(false);
  const [approvalDocument, setApprovalDocument] = useState("");
  const [editData, setEditData] = useState({});
  const [dropDownState, setDropdownState] = React.useState({ status: false });
  const [tableData, setTableData] = React.useState([]);
  const [tableCheckbox, setTableCheckbox] = React.useState({});

  const [gfcfApporvers, setgfcfApporvers] = useState([
    "firstGfcf",
    "gfcf",
    "gCad",
    "businessOwner"
  ]);






  React.useEffect(async () => {
    
    if (localStorage.getItem("auth") != undefined) {
      setLoading(true)
      setState({ ...state, ...router.query });
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setAuthData(auth);
      let authCheck = await JSON.parse(localStorage.getItem("auth")).data;

      let expiryStatus = await props.checkExpiry(authCheck);
      if (expiryStatus) {
        
      
      const getBotToApprove = await axios({
        method: "GET",
        url: `${endpoints.baseUrl}/bot/getBotUsingId?botID=${window.atob(router.query.botID)}`,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      });

      if (getBotToApprove.data.code == 403) {
        setLoading(false)
        props.sessionTimeOutCheck(true)
      }
      else {
        setProcessData({ ...getBotToApprove.data.data });
      }
    


      let editDataoth = {
        ["1.PleaseSelectTheProcessArea"]:
          getBotToApprove.data.data.firstLevelControlProcessArea,
        ["2.PleaseSelectTheSub-ProcessArea"]:
          getBotToApprove.data.data.firstLevelControlSubProcessArea,
      };
      
      setEditData({ ...editDataoth });

      let botData = getBotToApprove.data.data;

      let is = {
        controlActivity: botData.firstLevelControlActivity,
        kfaIuc: botData.kfaIuc,
      };

      let previouslyFilledControlActivityandKfaIuc = {}

      if (auth.userType == "gfcf" || auth.userType == "firstGfcf" || auth.userType == "businessOwner" || auth.userType == "gCad" || auth.userType == "landscape" || auth.userType == "infosec" ) {
      
        if (botData.firstLevelControlTable && botData.firstLevelControlActivity) {
         
         
          await sendDataToApproval(
            {
              process: botData.firstLevelControlProcessArea,
              subProcess: botData.firstLevelControlSubProcessArea,
            },
            
            JSON.parse(botData.firstLevelControlTable), true
          );
        } 



        previouslyFilledControlActivityandKfaIuc = { 
          dropData :    {
                        process: botData.firstLevelControlProcessArea,
                         subProcess: botData.firstLevelControlSubProcessArea,
                         },
          ...is

      }

      }

      let previouslyFilledCommentsandStatus = {}
     
      switch (auth.userType) {
        case "firstGfcf":
          
          previouslyFilledCommentsandStatus =  { status : botData.firstLevelgfcfApprovalStatus ? "Approve" : botData.firstLevelgfcfApprovalStatus === false ? "Reject" : null , comments : botData.firstLevelGfcfComment}
         
          break;
        case "gfcf":
          previouslyFilledCommentsandStatus = {...state, status : botData.secondLevelGfcfApprovalStatus? "Approve" : botData.secondLevelGfcfApprovalStatus === false ? "Reject" : null, comments : botData.secondLevelGfcfComment}
          
          break;
        case "firstLevelGPMApprover":
          
          previouslyFilledCommentsandStatus = {...state, status : botData.firstLevelGpmApprovalStatus ? "Approve" : botData.firstLevelGpmApprovalStatus === false ? "Reject" : null, comments : botData.firstLevelGpmComment}
        
          break;
        case "GPMapprover":
          previouslyFilledCommentsandStatus = {...state, status : botData.secondLevelGpmApprovalStatus ? "Approve" : botData.secondLevelGpmApprovalStatus === false ?  "Reject" : null, comments : botData.secondLevelGpmComment}
          
          break;
        case "gCad":
          previouslyFilledCommentsandStatus = {...state, status : botData.gcadApprovalStatus ? "Approve" : botData.gcadApprovalStatus === false ?   "Reject" : null, comments : botData.gcadComments}
          
         
	 break;
          case "landscape":
            previouslyFilledCommentsandStatus = {...state, status : botData.landscapeApprovalStatuss ? "Approve" : botData.landscapeApprovalStatuss === false ?   "Reject" : null, comments : botData.landscapeComments}
            
            break;
            case "infosec":
              previouslyFilledCommentsandStatus = {...state, status : botData.infosecApprovalStatuss ? "Approve" : botData.infosecApprovalStatuss === false ?   "Reject" : null, comments : botData.infosecComments}
              
              break;
          case "businessOwner":
            previouslyFilledCommentsandStatus = {...state, comments : botData.businessOwnerComments}
        
            break;

        default:
          break;
      }
      setState({...state, ...previouslyFilledCommentsandStatus, ...previouslyFilledControlActivityandKfaIuc })
      setUserType(auth.userType);
    } else {
      // router.push("/login");
      props.sessionTimeOutCheck(true)
    setLoading(false)
    }
  
    setLoading(false)
  }
    
  }, [router.query]);


 //Retrienving Control number on DropDown Data Change
  useEffect(() => {
    const controlNumber = [];
    Object.keys(tableCheckbox).forEach((item, idx) => {
      tableData.forEach((data, index) => {
        if (idx === index) {
          controlNumber.push(data.control);
        }
      });
    });
    setState({ ...state, controlNumber: controlNumber.join(",") });
console.log(state,"state");
  }, [tableCheckbox]);


  // getting control table data and setting it up 

  const sendDataToApproval = async (dropData, controlTable, start) => {
   

    for (let i in dropData) {
      if (dropData[i] == "") {
        delete dropData[i];
      }
    }
  

    
    if (!start) {
      setState({
        ...state,
        dropData,
      });

    }
     
    
  

    let authCheck = JSON.parse(localStorage.getItem("auth")).data;
    let expiryStatus = await props.checkExpiry(authCheck);

    if (expiryStatus) {
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setAuthData(auth);
      axios({
        method: "get",
        url: `${endpoints.baseUrl}/gfcf/getGfcf`,
        params: dropData,
        headers: {
          Authorization: `${auth.accessToken}|${auth.email}`,
        },
      }).then((response) => {
       
        if (response.data.code == 200) {
          if (controlTable) {
            let newCheckBox = {};
            controlTable.map((firstItem) => {
              response.data.data.map((secondItem, index) => {
                if (firstItem.control == secondItem.control) {
                  newCheckBox[index] = {
                    checked: true,
                    mitigationComment: firstItem.mitigationComment,
                  };
                }
              });
            });

            
            setTableCheckbox(newCheckBox);
            
            setTableData([...response.data.data]);
            //	alert("hii2")
          } else {
            setTableData([...response.data.data]);
            setTableCheckbox({});
            setEditData({});
          }
        } else if (response.data.code == 403) {
          localStorage.removeItem("auth");
          sessionStorage.clear();
          props.sessionTimeOutCheck(true);
          setLoading(false)
        }
      });
    } else {
      props.sessionTimeOutCheck(true);
      setLoading(false)
    }
  };






//  for status dropdown
 
  const handleDropDown = (item) => {
    setDropdownState({ ...dropDownState, [item]: !dropDownState[item] });
  };

  const gotDropDownValue = (value, dropdownParent, haveRelated) => {
    setDropdownState({ ...dropDownState, [dropdownParent]: false });
    setState({ ...state, [dropdownParent]: value });
  };





	const inputChange = (e) => {
    if (e.target.value == "yes") {
      setState({
        ...state,
        [e.target.name]: true,
        controlActivityType: "Global",
      });
    } else if (e.target.value == "no") {
      setState({
        ...state,
        [e.target.name]: false,
        controlActivityType: "None",
      });
    } else {
      setState({ ...state, [e.target.name]: e.target.value });
    }
  };





  const submitFormData = async () => {
    let moveAhead = true;
    const requiredFields = ["comments", "status"];
    for (let i in requiredFields) {
      if (
        (authData.userType != "businessOwner" &&
          (state[requiredFields[i]] === "" ||
            //state[requiredFields[i]] === false ||
            state[requiredFields[i]] === undefined ||
            state[requiredFields[i]] == undefined ||
            state[requiredFields[i]] == "undefined" ||
            state[requiredFields[i]] == null)) ||
        state.controlActivity
          ? state.dropData.process === undefined ||
            state.dropData.subProcess === undefined ||
            state.dropData.process === "undefined" ||
            state.dropData.subProcess === "undefined"
          : false	
      ) {
        moveAhead = false;
      } else if (authData.userType == "businessOwner") {
        if (
          state["comments"] == "" ||
          state["comments"] == undefined ||
          state["comments"] == null
        ) {
          moveAhead = false;
        }
      }
    }
    if (moveAhead) {
      let dataToSend;
      let controlTableJson = "";
      if (_.isEmpty(tableCheckbox) != true && state.controlActivity) {
        //console.log(tableCheckbox, "tableCheckbox");
        
        let controlTableDataArray = [];

        for (let i in tableCheckbox) {
          if (tableCheckbox[i].checked == true) {
            let tableDataToAdd = tableData[i];
            tableDataToAdd.mitigationComment = tableCheckbox[i].mitigationComment;
            controlTableDataArray.push(tableDataToAdd);
          }
        }

        controlTableJson = JSON.stringify(controlTableDataArray);
      }

      if (authData.userType == "firstGfcf") {
        //console.log("State  ----", state);
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            firstLevelgfcfApprover: authData.name,
            firstLevelgfcfApprovalStatus:
              state.status == "Approve" ? true : state.status == "Reject"? false : null,
            firstLevelGfcfComment: state.comments,
            firstLevelGfcfApprovalDate: Date.now(),
            firstLevelControlActivity: state.controlActivity,
            firstLevelControlTable: controlTableJson,
            firstLevelControlProcessArea: state.controlActivity ?  state.dropData.process : "",
            firstLevelControlSubProcessArea: state.controlActivity ? state.dropData.subProcess : "",
            kfaIuc: state.kfaIuc,
	    controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
        //console.log(dataToSend, "datatosend");
      } else if (authData.userType == "firstLevelGPMApprover") {
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            firstLevelGpmApprover: authData.name,
            firstLevelGpmApprovalStatus:
              state.status == "Approve" ? true : state.status == "Reject"? false : null,
            firstLevelGpmComment: state.comments,
            firstLevelGpmApprovalDate: Date.now(),
		controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
      } else if (authData.userType == "gfcf") {
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            secondLevelGfcfApprover: authData.name,
            secondLevelGfcfApprovalStatus:
              state.status == "Approve" ? true : state.status == "Reject"? false : null,
            secondLevelGfcfComment: state.comments,
            secondLevelGfcfApprovalDate: Date.now(),
            firstLevelControlActivity: state.controlActivity,
            firstLevelControlTable: controlTableJson,
            firstLevelControlProcessArea: state.dropData.process,
            firstLevelControlSubProcessArea: state.dropData.subProcess,
            kfaIuc: state.kfaIuc,
controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
      } else if (authData.userType == "GPMapprover") {
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            secondLevelGpmApprover: authData.name,
            secondLevelGpmApprovalStatus:
              state.status == "Approve" ? true : state.status == "Reject"? false : null,
            secondLevelGpmComment: state.comments,
            secondLevelGpmApprovalDate: Date.now(),
	controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
      }  
      else if(authData.userType == "landscape"){
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            landscapeApprovers: authData.name,
            landscapeApprovalStatuss: state.status == "Approve" ? true : state.status == "Reject"? false : null,
            landscapeApprovalDate: Date.now(),
            landscapeComments: state.comments,
		controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,

          },
        };

      }
      else if(authData.userType =="infosec"){
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds:{
            infosecApprovers: authData.name,
            infosecApprovalStatuss: state.status == "Approve" ? true : state.status == "Reject"? false : null,
            infosecApprovalDate: Date.now(),
            infosecComments: state.comments,
		controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
    }else if (authData.userType == "gCad") {
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            firstLevelControlActivity: state.controlActivity,
            firstLevelControlTable: controlTableJson,
            firstLevelControlProcessArea: state.dropData.process,
            firstLevelControlSubProcessArea: state.dropData.subProcess,
            gcadApprover: authData.name,
            kfaIuc: state.kfaIuc,
            gcadApprovalStatus: state.status == "Approve" ? true : state.status == "Reject"? false : null,
            gcadApprovalDate: Date.now(),
            gcadComments: state.comments,
	controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
      } else if (authData.userType == "businessOwner") {
        dataToSend = {
          botID: processData.botID,
          toUpdateBotFileds: {
            businessOwnerComments: state.comments,
            firstLevelControlActivity: state.controlActivity,
            firstLevelControlTable: controlTableJson,
            firstLevelControlProcessArea: state.dropData.process,
            firstLevelControlSubProcessArea: state.dropData.subProcess,
            kfaIuc: state.kfaIuc,
		controlActivityType: state.controlActivityType,
            controlNumber: state.controlNumber,
          },
        };
      }
      //console.log("state ---",authData.userType, state);
      //console.log("final data to send", dataToSend);
      if (
        authData.userType != "businessOwner" &&
        (state["status"] == undefined || state["comments"] == undefined)
      ) {
        //console.log("here");
        setMessage(
          "Update the status to Approve/Reject and add some approval message"
        );
        setSuccessModal(true);
        return;
      } else if (
        authData.userType == "businessOwner" &&
        state["comments"] == undefined
      ) {
        setMessage("Add Some Comments");
        setSuccessModal(true);
        return;
      }

      //console.log(approvalDocument, "approvalDocument");
      //console.log(endPoints.fetchBlobUrl, "fetchBlob");
      if (approvalDocument != "") {
        switch (authData.userType) {
           case ("firstGfcf"): 
           dataToSend.toUpdateBotFileds.firstLevelGfcfApprovalDocumentLink = approvalDocument;
           break;
           case ("gfcf"): 
           dataToSend.toUpdateBotFileds.secondLevelGfcfApprovalDocumentLink = approvalDocument;
           break;
           case ("firstLevelGPMApprover"): 
           dataToSend.toUpdateBotFileds.firstLevelGpmApprovalDocumentLink = approvalDocument;
           break;
           case ("GPMapprover"): 
           dataToSend.toUpdateBotFileds.secondLevelGpmApprovalDocumentLink = approvalDocument;
           break;
           case ("businessOwner"): 
           dataToSend.toUpdateBotFileds.businessOwnerApprovalDocumentLink = approvalDocument;
           break;
	    case ("landscape"): 
           dataToSend.toUpdateBotFileds.landscapeApprovalDocumentLink = approvalDocument;
           break;
           case ("infosec"): 
           dataToSend.toUpdateBotFileds.infosecApprovalDocumentLink = approvalDocument;
           break;
           case ("gCad"):
           dataToSend.toUpdateBotFileds.gCadApprovalDocumentLink = approvalDocument;
        }
        //dataToSend.toUpdateBotFileds.approvalDocumentLink = approvalDocument;
      }

      //console.log("data to send  ----", dataToSend);
      //return;

      let authCheck = JSON.parse(localStorage.getItem("auth")).data;
      let expiryStatus = await props.checkExpiry(authCheck);

      if (expiryStatus) {
        let auth = JSON.parse(localStorage.getItem("auth")).data;
        setAuthData(auth);

        setLoading(true);
        axios({
          method: "put",
          url: `${endpoints.baseUrl}/bot/approveBot`,
          data: dataToSend,
          headers: {
            Authorization: auth.accessToken,
          },
        }).then((response) => {
          //console.log("response", response);
          if (response.data.code == 200) {
            //props.data[1].component.content.field_message_type_value_pair[0].field_message
            setMessage(
              props.data[1].component.content.field_message_type_value_pair[0]
                .field_message
            );
            setSuccessModal(true);
            setLoading(false);
          } else if (response.data.code == 403) {
            localStorage.removeItem("auth");
            sessionStorage.clear();
            props.sessionTimeOutCheck(true);
            setLoading(false)
            setFail(true);
          } else if (response.data.code == 404) {
            setMessage(
              props.data[1].component.content.field_message_type_value_pair[1]
                .field_message[0]
            );
            setSuccessModal(true);
            setFail(true);
          }
        });
      } else {
        props.sessionTimeOutCheck(true);
        setLoading(false)
      }
    } else {
      setInvalidFlag(true);
    }
  };



// table checkbox change


  const checkBoxChange = (e, index) => {
    if (e.target.checked == true) {
      setTableCheckbox({
        ...tableCheckbox,
        [index]: { ...tableCheckbox[index], checked: true },
      });
    } else {
      setTableCheckbox({
        ...tableCheckbox,
        [index]: { ...tableCheckbox[index], checked: false },
      });
    }
  };


// table comments change

  const tableMitigationChange = (e, index) => {
    setTableCheckbox({
      ...tableCheckbox,
      [index]: { ...tableCheckbox[index], mitigationComment: e.target.value },
    });
  };



// document upload

  const blobSasUrlNew = endpoints.blobSasUrlNew;

  const blobServiceClient = new BlobServiceClient(blobSasUrlNew);

  const containerClient = blobServiceClient.getContainerClient("botstorevideo");

  const uploadFile = async (file, name) => {
    //console.log(file);
    setShowFileName(true);

    let fileNameOriginal = file.name;
    //	setLoader(true)
    let fileNameWithSpaces = fileNameOriginal+Date.now();
    let fileName = fileNameWithSpaces.replace(/ /g, "");
    let ar = fileNameOriginal.split(".");
    let extension = ar[ar.length - 1];
    const fileSize = file.size;
    setLoading(true)
    try {
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);
      const options = { blobHTTPHeaders: { blobContentType: file.type } };
      const resp = await blockBlobClient.uploadBrowserData(file, options);
      //console.log(resp, "response of azure");
      let url = resp._response.request.url;
      //console.log(url, "ye url chahiye");
      let ar = url.split("?");
      let another = ar[0].split("/");
      let toSend = another[another.length - 1];
      setApprovalDocument(toSend);
      let auth = JSON.parse(localStorage.getItem("auth")).data;
      setLoading(false)
      //console.log(extension, "ext", fileNameOriginal, "ori", toSend);
    } catch (error) {
      console.log(error, "erro");
      alert("Could not upload");
    }
  };









  return (
    <div className={styles.formContainer}>
      {Loading ? <Loader /> : null}
      <p className={styles.head}>
        {props.data[0].component.content.field_title}
      </p>
      <div className={styles.parentForm}>
        <div className={styles.inputGroup}>
          <label>
            {
              props.data[0].component.content.field_approval_form_component[0]
                .field_title
            }
          </label>
          <input
            type="text"
            placeholder="Approver Name"
            name="remark"
            disabled
            defaultValue={authData.name}
          />
        </div>
        {/* quest 1 */}
        <p className={styles.ques1}>
          {
            props.data[0].component.content.field_approval_form_component[1]
              .field_title
          }
        </p>
        <div className={styles.Group}>
          <label>
            {
              props.data[0].component.content.field_approval_form_component[1]
                .field_label
            }
          </label>
          
          <input
            type="text"
            placeholder="1035"
            disabled
            defaultValue={processData.botExternalId}
          />
          
          <input
            type="text"
            placeholder="1035"
            hidden={true}
            disabled
            defaultValue={processData.botID}
          />
        </div>
        <div className={styles.Group}>
          <label>
            {
              props.data[0].component.content.field_approval_form_component[2]
                .field_label
            }
          </label>
          <input
            type="text"
            placeholder="Cd Operations"
            disabled
            defaultValue={processData.processName}
          />
        </div>
        <div className={styles.Group}>
          <label>
            {
              props.data[0].component.content.field_approval_form_component[3]
                .field_label
            }
          </label>
          <input
            type="text"
            placeholder="Function"
            disabled
            defaultValue={processData.leadPlatform}
          />
        </div>

        <div className={styles.Group}>
          <label>
            {
              props.data[0].component.content.field_approval_form_component[4]
                .field_label
            }
          </label>
          <input
            type="text"
            placeholder="Cd Operations"
            disabled
            defaultValue={processData.area}
          />
        </div>
{/* quest 2 */}
        <p className={styles.ques1}>
          {
            props.data[0].component.content.field_approval_form_component[5]
              .field_title
          }
        </p>
        <div className={styles.Group}>
          <textarea
            placeholder="please enter your address"
            className={styles.area}
            name="briefDescription"
            defaultValue={processData.processDescription}
            disabled
          />
        </div>
        {authData.userType == "firstGfcf" ||
        authData.userType == "gfcf" ||
        authData.userType == "gCad" ||
        authData.userType == "businessOwner"
        ? (
          <div>
            <p className={styles.ques1}>
              3.   
              {
               `  ${props.data[0].component.content.field_approval_form_component[6]
                  .field_title} *`
              }
            </p>





          {/* control activity radio */}

            <div className={styles.Group} onChange={inputChange}>
              <div className={styles.radio}>
                <label className={styles.radioWrapper}>
                  <span className={styles.subLabel}>Yes</span>
                  <input
                    type="radio"
                    className={styles.radioBox}
                    checked={state.controlActivity == null ? false : state.controlActivity ? true : false}
                    name="controlActivity"
                    value="yes"
                  />
                  <span className={styles.radioCheckmark}></span>
                </label>
              </div>
              <div className={styles.radio}>
                <label className={styles.radioWrapper}>
                  <span className={styles.subLabel}>No</span>
                  <input
                    type="radio"
                    className={styles.radioBox}
                    checked={state.controlActivity == null ? false : state.controlActivity === false ? true : false}
                   
                    name="controlActivity"
                    value="no"
                  />
                  <span className={styles.radioCheckmark}></span>
                </label>
              </div>
            </div>

		       {/*  Control Imapcted Type */}

            {state.controlActivity && (
              <>
                <p className={styles.ques1}>
                  4.
                  {` Control impacted type: * `}
                </p>
                <div className={styles.Group} onChange={inputChange}>
                  <div className={styles.radio}>
                    <label className={styles.radioWrapper}>
                      <span className={styles.subLabel}>Global</span>
                      <input
                        type="radio"
                        className={styles.radioBox}
                        checked={
                          state.controlActivityType === "Global" ? true : false
                        }
                        name="controlActivityType"
                        value="Global"
                      />
                      <span className={styles.radioCheckmark}></span>
                    </label>
                  </div>
                  <div className={styles.radio}>
                    <label className={styles.radioWrapper}>
                      <span className={styles.subLabel}>Local</span>
                      <input
                        type="radio"
                        className={styles.radioBox}
                        checked={
                          state.controlActivityType === "Local" ? true : false
                        }
                        name="controlActivityType"
                        value="Local"
                      />
                      <span className={styles.radioCheckmark}></span>
                    </label>
                  </div>
                  <div className={styles.radio}>
                    <label className={styles.radioWrapper}>
                      <span className={styles.subLabel}>
                        Both (global and local)
                      </span>
                      <input
                        type="radio"
                        className={styles.radioBox}
                        checked={
                          state.controlActivityType ===
                          "Both (global and local)"
                            ? true
                            : false
                        }
                        name="controlActivityType"
                        value="Both (global and local)"
                      />
                      <span className={styles.radioCheckmark}></span>
                    </label>
                  </div>
                </div>
              </>
            )}




            {/* control activity table */}

            {state.controlActivity ? (
              <div>
                <p className={styles.ques1}>
                  {state.controlActivityType === "None" ? "4. " : "5. "}
                  {
                    `  ${props.data[0].component.content
                      .field_approval_form_component[7].field_title}`
                  }
                </p>
                <div className={styles.ques4}>
                  <BasicForm
			invalidFlag={invalidFlag}
                    state={state}                   
 			data={dropDownAr}
                   // sendFormValues={recievedFormValues}
                    getFormValues={getFormValues}
                    emptyFormValues={emptyFormValues}
                    sendDataToApproval={sendDataToApproval}
                    formType={"approval"}
                    approvalEditData={editData}
                    editData={editData}
                    
                  />
                </div>
                <div className={styles.scrollableTable}>
                  <span style={{ fontSize: "12px", fontWeight: "normal" }}>
                    3.
                  </span>
                  <table>
                    <thead>
                      <tr>
                        <th>Control Number</th>
                        <th>Control Name</th>
                        <th>Control Description</th>
                        <th>Impact</th>
                        <th>Mitigation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((item, index) => (
                        <tr>
                          <td>{item.control}</td>
                          <td>{item.controlName}</td>
                          <td>{item.controlDescription}</td>
                          <td>
                            <div className={styles.check}>
                              <label className={styles.list_Checkbox_container}>
                                <input
                                  type="checkbox"
                                  onChange={(e) => {
                                    checkBoxChange(e, index);
                                  }}
                                  checked={
                                    tableCheckbox[index]
                                      ? tableCheckbox[index].checked
                                        ? true
                                        : false
                                      : false
                                  }
                                />
                                <span className={styles.list_checkmark}></span>
                              </label>
                            </div>{" "}
                          </td>
                          <td>
                            {" "}
                            <textarea
                              placeholder="comments"
                              onChange={(e) => {
                                tableMitigationChange(e, index);
                              }}
                              key={
                                _.isEmpty(tableCheckbox) ? "notLoded" : "loaded"
                              }
                              defaultValue={
                                tableCheckbox[index]
                                  ? tableCheckbox[index].mitigationComment
                                  : ""
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : null}
          </div>
        ) : null}






        {/* kfa radio */}

        {processData.kfa == true &&
        gfcfApporvers.includes(authData.userType) ? (
          <div>
            <p className={styles.ques1}>
              {state.controlActivity ? "5. " : "4. "}
              {
                props.data[0].component.content.field_approval_form_component[9]
                  .field_title
              }
            </p>
            <div className={styles.Group} onChange={inputChange}>
              <div className={styles.radio}>
                <label className={styles.radioWrapper}>
                  <span className={styles.subLabel}>Yes</span>
                  <input
                    type="radio"
                    className={styles.radioBox}
                    name="kfaIuc"
                    value="yes"
                    checked={
                      (state.kfaIuc == null)
                        ? false
                        : state.kfaIuc
                        ? true
                        : false
                    }
                  />
                  <span className={styles.radioCheckmark}></span>
                </label>
              </div>
              <div className={styles.radio}>
                <label className={styles.radioWrapper}>
                  <span className={styles.subLabel}>No</span>
                  <input
                    type="radio"
                    className={styles.radioBox}
                    name="kfaIuc"
                    checked={
                      (state.kfaIuc == null)
                        ? false
                        : state.kfaIuc === false 
                        ? true
                        : false
                    }
                    value="no"
                  />
                  <span className={styles.radioCheckmark}></span>
                </label>
              </div>
            </div>
          </div>
        ) : null}
         {authData.userType == "infosec" ?  
        (
          <>
        
        <div >
        <p className={styles.ques1}>
          3.
          {
            
            props.data[0].component.content.field_approval_form_component[12]
              .field_title
          }
        </p>
        <div className={styles.Group_sub}>
          <input
          type="text"
          placeholder="1030"
          disabled
          defaultValue={processData.dataClassification}
          />
        </div>
          
        </div>
       
        <div >
        <p className={styles.ques1}>
          4.
          {
            
            props.data[0].component.content.field_approval_form_component[13]
              .field_title
          }
        </p>
        <div className={styles.Group_sub}>

          <input
            type="text"
            placeholder="1035"
            disabled
            defaultValue={processData.applications}
          />
          </div>
        </div>
       
        <div >
        <p className={styles.ques1}> 
          5.
          {
            
            props.data[0].component.content.field_approval_form_component[14]
              .field_title
          }
        </p>
        <div className={styles.Group_sub}>

          <input
           type="text"
           placeholder="1035"
           disabled
           defaultValue={processData.kfa}
          />
          </div>
        </div>
        <><span className={styles.ques1}>
            
            6.
            {props.data[0].component.content.field_approval_form_component[10]
              .field_title + "*"}
          </span>
          {/* <span className={styles.ques1}>
            
             
            {props.data[0].component.content.field_approval_form_component[12]
              .field_title + "*"}
          </span> */}
          </>
      
          </>
          
        )
: 
null
} 


     {/* comments */}

        {
        authData.userType == "firstLevelGPMApprover" ||
        authData.userType == 'GPMapprover' ||
         authData.userType == 'landscape'  ? (
          <>
          <span className={styles.ques1}>
            
            3.
            {props.data[0].component.content.field_approval_form_component[10]
              .field_title + " "}
          </span>
          {/* <span className={styles.ques1}>
            
             
            {props.data[0].component.content.field_approval_form_component[12]
              .field_title + "*"}
          </span> */}
          </> 
        ) : authData.userType !== 'infosec' &&(
          <span className={styles.ques1}>
            
           {state.controlActivity ? "6. " : state.controlActivityType === "None" ? "4. " : "5. "}

            {props.data[0].component.content.field_approval_form_component[10]
              .field_title + "*"}
          </span>
        )}



        <div className={styles.areaGroup}>
          {invalidFlag && !state.comments ? (
            <span className={styles.errorMessage}>
              Comments cannot be empty
            </span>
          ) : null}
          <textarea
            placeholder={
              props.data[0].component.content.field_approval_form_component[10]
                .field_placeholder
            }
            className={styles.area}
            name="comments"
            onChange={inputChange}
            value = {state.comments}
          />
        </div>

        {/* status */}

        {authData.userType != "businessOwner" ? (
          <>
          <span className = {styles.ques1}>
            <label>
              <span>

              {gfcfApporvers.includes(authData.userType) ? state.controlActivity ? "7. " : state.controlActivityType === "None" ? "5. "  : "6. " : authData.userType == "infosec" ? "7. " : "4. "}
              
                {props.data[0].component.content
                  .field_approval_form_component[11].field_label + "*"}
              </span>
              {invalidFlag && !state["status"] ? (
                <span className={styles.errorMessage}>
                  Please select a status
                </span>
              ) : null}
            </label>
            </span>

            <div className={styles.inputGroupDropdown}>
            <p
              className={`${styles.input}`}
              onClick={() => {
                handleDropDown("status");
              }}
            >
              <span className={styles.left}>
                {   state["status"] == null ?  "select status" : state["status"]}
              </span>
              <span className={styles.right}>
                <Icons name="chevron" className={styles.chevron} />
              </span>
            </p>
            {dropDownState["status"] == true ? (
              <Dropdown
                dropdownParent={"status"}
                values={["Approve", "Reject"]}
                getDropdownValue={gotDropDownValue}
                haveRelated={null}
                className={styles.dropStatus}
              />
            ) : null}
          </div>
          </>
        ) : null}
       






  
       

      







      {/* Document Uploader */}


         <span className = {styles.ques1}>
         { gfcfApporvers.includes(authData.userType) ?  state.controlActivity ?
            authData.userType != "businessOwner"
              ? "8. "
              :
               "7. "
               :  authData.userType != "businessOwner" ?  "7. " : "6."  : state.controlActivity ?  "6. " :  authData.userType == 'infosec'? "8. ": "5. "
              }
        
         Upload Document
         </span>
          <div className={styles.Group}>
            
            <UploadFile
              type="approvalForm"
              uploadFile={uploadFile}
              uploaded={showFileName}
              fileType={[".pdf", ".doc", ".docx"]}
              value="approvalDocument"
            />
          </div>


       

          {/* Document Links */}


          {
        authData.userType == "firstGfcf" || authData.userType == "gfcf" ? 
        <div className = {styles.documentLinkWrapper}>
        <>
        {
          processData.firstLevelGfcfApprovalDocumentLink 
          ? 
          <div className={styles.Group}>
          <p className={styles.ques1}> First level GFCF approval document</p>
          <span className = {styles.documentLink}> <a href= { endPoints.fetchBlobUrl+"/"+processData.firstLevelGfcfApprovalDocumentLink} target="_blank">{processData.firstLevelGfcfApprovalDocumentLink }</a></span>
        </div> : null}
       </>
       <>
       {
          processData.secondLevelGfcfApprovalDocumentLink 
          ? 
          <div className={styles.Group}>
          <p className={styles.ques1}> Second level GFCF approval document</p>
          <span className = {styles.documentLink}><a target= "_blank" href={endPoints.fetchBlobUrl+"/"+processData.secondLevelGfcfApprovalDocumentLink}>{processData.secondLevelGfcfApprovalDocumentLink }</a></span>
        </div> : null}
       </>
       </div>
       :
       authData.userType == "GPMapprover" || authData.userType == "firstLevelGPMApprover" ?
       <div className = {styles.documentLinkWrapper}>
       
       {
         processData.firstLevelGpmApprovalDocumentLink 
         ? 
         <div className={styles.Group}>
         <p className={styles.ques1}> First level GPM approval document</p>
         <span className = {styles.documentLink }> <a target= "_blank" href={endPoints.fetchBlobUrl+"/"+processData.firstLevelGpmApprovalDocumentLink}>{processData.firstLevelGpmApprovalDocumentLink }</a></span>
       </div> : null}
      
      
      {
         processData.secondLevelGpmApprovalDocumentLink 
         ? 
         <div className={styles.Group}>
         <p className={styles.ques1}> Second level GPM approval document</p>
         <span className = {styles.documentLink }><a target= "_blank" href={endPoints.fetchBlobUrl+"/"+processData.secondLevelGpmApprovalDocumentLink}>{processData.secondLevelGpmApprovalDocumentLink }</a></span>
       </div> : null}
      </div>
      : 
      authData.userType == "gCad" ?
      <div className = {styles.documentLinkWrapper}>
      {
        processData.gCadApprovalDocumentLink ? 
        <div className={styles.Group}>
         <p className={styles.ques1}> GCAD approval document</p>
         <span className = {styles.documentLink }> <a target = "_blank" href= {endpoints.fetchBlobUrl+"/"+processData.gCadApprovalDocumentLink }>{processData.gCadApprovalDocumentLink }</a></span>
       </div> : null
      }
      </div>
      : 
       authData.userType == "landscape" ?
      <div className = {styles.documentLinkWrapper}>
      {
        processData.landscapeApprovalDocumentLink ? 
        <div className={styles.Group}>
         <p className={styles.ques1}> Landscape approval document</p>
         <span className = {styles.documentLink }> <a target = "_blank" href= {endpoints.fetchBlobUrl+"/"+processData.landscapeApprovalDocumentLink }>{processData.landscapeApprovalDocumentLink }</a></span>
       </div> : null
      }
      </div>
      : 
	
      authData.userType == "businessOwner" ?
      <div className = {styles.documentLinkWrapper}>
      {
        processData.businessOwnerApprovalDocumentLink ? 
        <div className={styles.Group}>
         <p className={styles.ques1}> Business Owner approval document</p>
         <span className = {styles.documentLink }> <a target = "_blank" href= {endpoints.fetchBlobUrl+"/"+processData.businessOwnerApprovalDocumentLink}>{processData.businessOwnerApprovalDocumentLink }</a></span>
       </div> : null
      }
      </div>
      
        : null
       }




        
        <div className={styles.bottomBtns}>
          <span className={styles.btn} onClick={submitFormData}>
            {props.data[0].component.content.field_submit_button_text}
          </span>
          <span
            className={styles.btn}
            onClick={() => {
              router.push("/approvals");
            }}
          >
            Back to Approval
          </span>
        </div>
      </div>
      {successModal ? (
        <SuccessModal
          setSuccessModal={() => router.push("/approvals")}
          title={"Approval Form"}
          message={message}
          fail={fail}
          setFail={setFail}
        />
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

